import { cn } from '~/lib/utils'

// The special-challenge progress bar the entry card and the detail view
// share: white-bordered track, gradient fill, centered n/target label. The
// track and fill colors are per-event config values; a full bar switches to
// the completed palette (grey track, white label), per the Figma bar
// sheet's 750/750 variant.
export function SpecialProgressBar(props: {
  progress: number
  target: number
  trackColor: string
  fillBg: string
}) {
  const full = () => props.target > 0 && props.progress >= props.target
  const fillPct = () => {
    if (props.target <= 0) return 0
    return Math.min(100, Math.max(0, (props.progress / props.target) * 100))
  }
  return (
    <div class="relative h-[30px] w-full">
      <div
        class="h-full w-full rounded-[8px] border-[3px] border-white"
        style={{ background: full() ? '#ececec' : props.trackColor }}
      />
      <div class="absolute inset-[3px]">
        <div
          class="h-full rounded-[4px] transition-[width] duration-500 ease-out"
          style={{ width: `${fillPct()}%`, background: props.fillBg }}
        />
      </div>
      <p
        class={cn(
          'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap text-sm font-semibold leading-[20px]',
          full() ? 'text-white' : 'text-black/40',
        )}
      >
        {props.progress}/{props.target}
      </p>
    </div>
  )
}
